var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg123PaintBucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452,174.098h-20.003c-0.233-46.645-18.54-90.334-51.61-123.111C347.215,18.107,303.04,0,256,0 c-47.04,0-91.215,18.107-124.388,50.986c-33.07,32.777-51.376,76.467-51.61,123.111H60c-11.046,0-20,8.954-20,20s8.954,20,20,20 h20V432c0,44.112,35.888,80,80,80h192c44.112,0,80-35.888,80-80c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20 c0,22.056-17.944,40-40,40H160c-22.056,0-40-17.944-40-40V214.098h272V332c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20 V214.098h20c11.046,0,20-8.954,20-20C472,183.052,463.046,174.098,452,174.098z M120.003,174.098 C120.494,100.072,181.312,40,256,40s135.506,60.072,135.997,134.098H120.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,271c-11.046,0-20,8.954-20,20v100c0,11.046,8.954,20,20,20h152c11.046,0,20-8.954,20-20V291 c0-11.046-8.954-20-20-20H180z M312,371H200v-60h112V371z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg123PaintBucket);
export default __webpack_public_path__ + "static/media/123-paint-bucket.5b6cad075a658e763ff1ec804f2ae54b.svg";
export { ForwardRef as ReactComponent };